import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { AuthService } from 'app/core/services/auth.service';
import { HttpHeaderModel } from 'app/core/services/http-header-model';
import { HttpHeaderService } from 'app/core/services/http-header.service';
import { LocalStorageService } from 'app/core/services/local-storage.service';
import { LaboratoryAreaMessageService } from 'app/core/services/prothesis-api/pub/laboratory-area-message.service';
import { Area } from 'app/shared/enums/area.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatCardContent } from '@angular/material/card';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-laboratory-area-message-banner',
  styleUrls: ['./laboratory-area-message-banner.component.scss'],
  templateUrl: './laboratory-area-message-banner.component.html',
  imports: [MatCardContent, NgClass, MatIcon, MatIconButton, MatTooltip],
})
export class LaboratoryAreaMessageBannerComponent implements OnInit {
  public static strKeyLaboratoryAreaMessageClosed = 'laboratory-area-message-closed';
  public displayFlag: boolean;
  public etag: number | null;
  public etagFromHttpHeader: number | null | undefined;
  public getInfoLaboratoryAreaMessageScheduled = false;
  public isAdminOrSuperAdminFlag = false;
  public laboratoryAreaMessageClosed: number;
  public link: string | null;
  public style: string | null;
  public text: string | null;
  public textLink: string | null;

  private _authService = inject(AuthService);
  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _httpHeaderService = inject(HttpHeaderService);
  private _laboratoryAreamessageService = inject(LaboratoryAreaMessageService);
  private _localStorageService = inject(LocalStorageService);
  private _unsubscribeAll: Subject<void>;

  public constructor() {
    this._unsubscribeAll = new Subject();
  }

  public close(): void {
    this.displayFlag = false;
    this._localStorageService.write(LaboratoryAreaMessageBannerComponent.strKeyLaboratoryAreaMessageClosed, this.etagFromHttpHeader);
  }

  public ngOnInit(): void {
    this._authService.isDoneLoading$.pipe(takeUntil(this._unsubscribeAll)).subscribe((isDoneLoadingFlag) => {
      this._httpHeaderService.onHttpHeaderChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe((httpHeaderModel: HttpHeaderModel) => {
        if (isDoneLoadingFlag) {
          this.isAdminOrSuperAdminFlag = this._authService.isAdminOrSuperAdminFlag;
          this.laboratoryAreaMessageClosed = Number(
            this._localStorageService.read(LaboratoryAreaMessageBannerComponent.strKeyLaboratoryAreaMessageClosed),
          );
          this.etagFromHttpHeader = httpHeaderModel?.laboratoryAreaMessageEtag;
          this.displayFlag =
            this.etagFromHttpHeader !== null &&
            this.etagFromHttpHeader !== undefined &&
            this.etagFromHttpHeader !== this.laboratoryAreaMessageClosed &&
            (this._authService.area === Area.Laboratory || this._authService.area === Area.Admin || this._authService.area === Area.NoArea);

          if (this.etagFromHttpHeader === undefined || this.etagFromHttpHeader === null) {
            this.etag = null;
            this.link = null;
            this.style = null;
            this.text = null;
            this.textLink = null;
          } else if (this.etagFromHttpHeader !== httpHeaderModel?.previousLaboratoryAreaMessageEtag && this.displayFlag) {
            if (!this.getInfoLaboratoryAreaMessageScheduled) {
              this.getInfoLaboratoryAreaMessageScheduled = true;
              this.text = 'Un message est en cours de chargement...';
              setTimeout(() => {
                this._laboratoryAreamessageService.getInfoLaboratoryAreaMessage().subscribe((res) => {
                  this.etag = res.etag;
                  this.link = res.link;
                  this.style = res.style;
                  this.text = res.text;
                  this.textLink = res.textLink;

                  this.getInfoLaboratoryAreaMessageScheduled = false;

                  // Mark for check
                  this._changeDetectorRef.markForCheck();
                });
              }, 1000);
            }
          }

          // Mark for check
          this._changeDetectorRef.markForCheck();
        }
      });
    });
  }
}
